import { useEffect } from 'react'

export default function useScrollAnimation() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible')
          // Optional: Once it's visible, stop observing to keep it there
          // observer.unobserve(entry.target)
        }
      })
    }, observerOptions)

    const elements = document.querySelectorAll('.scroll-hidden')
    elements.forEach(el => observer.observe(el))

    return () => observer.disconnect()
  }, [])
}
